module.exports = __webpack_public_path__ + "img/1518820910.f9905d5e.jpg";